/**
 * Get Project Handler
 * 
 * CQRS Query Handler that delegates to ProjectQueryService.
 * Thin adapter layer for read operations.
 */

import { injectable, inject } from 'inversify';
import { DDD_SYMBOLS } from '../../../../infrastructure/di/DDD_SYMBOLS';
import { IQueryHandler } from '@swoft/core';
import { GetProjectQuery, ProjectDto } from '../queries/GetProjectQuery';
import { ProjectQueryService } from '../services/ProjectQueryService';

@injectable()
export class GetProjectHandler implements IQueryHandler<GetProjectQuery, ProjectDto | null> {
  constructor(
    @inject(DDD_SYMBOLS.ProjectQueryService) private projectQueryService: ProjectQueryService
  ) {}

  async handle(query: GetProjectQuery): Promise<ProjectDto | null> {
    const projectDto = await this.projectQueryService.getProject(query.projectId);
    
    if (!projectDto) {
      throw new Error(`Project with ID ${query.projectId} not found`);
    }

    return projectDto;
  }
}